import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function ColorSlider({
  data,
  value,
  defaultValue,
  onChange,
  isRemoveButtonClicked,
}) {
  const { t } = useTranslation();

  const [color, setColor] = useState(defaultValue);
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  useEffect(() => {
    setColor(value || defaultValue);
  }, [value, defaultValue]);

  useEffect(() => {
    if (isRemoveButtonClicked) {
      setColor(defaultValue);
      setIsPickerOpen(false);
    }
  }, [isRemoveButtonClicked, defaultValue]);

  const handleColorChange = (nextColor) => {
    setColor(nextColor);
    onChange?.(nextColor);
  };

  const handleResetSingle = (e) => {
    e.stopPropagation();
    setColor(defaultValue);
    onChange?.(defaultValue);
    setIsPickerOpen(false);
  };

  return (
    <div
      className="w-full mt-[0.94rem]"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="flex items-center justify-between gap-[0.75rem]">
        <div className="flex items-center gap-[0.63rem]">
          <div
            style={{ backgroundImage: `url(${data?.icon})` }}
            className="w-[1.5rem] h-[1.5rem] bg-no-repeat bg-center bg-contain"
          />
          <div className="text-[0.875rem] font-[500] text-text-black">
            {t(data?.title)}
          </div>
        </div>

        <div className="flex items-center gap-[0.63rem]">
          <button
            type="button"
            onClick={handleResetSingle}
            className="text-[0.75rem] font-[500] text-[#666]"
          >
            {t("Reset")}
          </button>

          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setIsPickerOpen((prev) => !prev);
            }}
            onMouseDown={(e) => e.stopPropagation()}
            className="w-[2rem] h-[2rem] rounded-[0.5rem] border border-inner-widget-border"
            style={{ backgroundColor: color }}
            aria-label={t(data?.title)}
          />
        </div>
      </div>

      {isPickerOpen && (
        <div
          className="mt-[0.75rem] w-full rounded-[0.75rem] border border-inner-widget-border p-[0.75rem] bg-white"
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <input
            type="color"
            value={color}
            onChange={(e) => handleColorChange(e.target.value)}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            className="w-full h-[2.5rem]"
          />

          <div className="mt-[0.75rem] flex items-center justify-between gap-[0.75rem]">
            <div className="flex-1 h-[2.5rem] rounded-[0.5rem] border border-inner-widget-border flex items-center px-[0.75rem] text-[0.875rem] text-text-black">
              {color}
            </div>

            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setIsPickerOpen(false);
              }}
              className="h-[2.5rem] px-[1rem] rounded-[0.5rem] border border-[#1212121A] text-[#121212] font-medium hover:bg-gray-100"
            >
              {t("Done")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ColorSlider;
